WarningBannerView = require 'app/scripts/views/header/warning-banner-view'
templates = require 'app/scripts/views/internal/templates'

module.exports = class TwoFactorBackupsBannerView extends WarningBannerView

  render: ->
    @$el.html(templates.fill('header_two_factor_backups_banner'))
    @
